// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import Home from './pages/Home';
import './App.css';
import CourtBooking from './components/CourtBooking';
import PaymentPage from './components/PaymentPage';



function App() {
  return (
    <Router>
      <GlobalStyles />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/booking" element={<CourtBooking />} />
        <Route path="/payment"  element={<PaymentPage />} />

      </Routes>
    </Router>
  );
}

export default App;
